module.exports = {"text":"עוצמתית או מעודנת?<br/>תערובות קפה במהדורה מוגבלת","link":"https://www.nespresso.com/il/he?utm_source=Ynet&utm_medium=content&utm_campaign=cardle_article","button":{"text":"לחצו כאן","link":""}}


//////////////////
// WEBPACK FOOTER
// ./src/api/FooterBanner.json
// module id = 64
// module chunks = 0